<!--
* @Description: 宿舍值班表 详情
* @Author: ZSC
* @Date: 2023-03-08 14:26:07.84
 * @LastEditors: PF
 * @LastEditTime: 2023-11-20 10:28:42
-->
<template>
  <div>
    <el-dialog class="w600 h500" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="学期" label-align="right" align="left" width="120px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="日期" label-align="right" align="left" width="120px" span="2">
          {{ruleForm.rq}} 星期{{week[ruleForm.xq]}}
        </el-descriptions-item>
        <el-descriptions-item label="周次" label-align="right" align="left" width="120px" span="2">{{ruleForm.zc}}</el-descriptions-item>
        <el-descriptions-item label="班次" label-align="right" align="left" width="120px" span="2">{{ruleForm.bcmc}}</el-descriptions-item>
        <el-descriptions-item label="时间" label-align="right" align="left" width="120px" span="2">
          <span v-if="ruleForm.zbkssj && ruleForm.zbjssj">{{ ruleForm.zbkssj }}-{{ ruleForm.zbjssj }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="宿舍管理区域" label-align="right" align="left" width="120px" span="2">{{ruleForm.ssglqymc}}</el-descriptions-item>
        <el-descriptions-item label="值班人" label-align="right" align="left" width="120px" span="2">{{ruleForm.zbrxm}}</el-descriptions-item>
        <el-descriptions-item label="是否值班" label-align="right" align="left" span="2">
          <span v-if="ruleForm.sfzb === true">是</span>
          <span v-if="ruleForm.sfzb === false">否</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({})
const week = ref(['', '一', '二', '三', '四', '五', '六', '日'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({ url: '/api/v2/sushe/sushezhibanbiao/' + props.row.id, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
